import { getConfiguration } from "./configuration";

export function getTournamentsHighlightsImages() {
	const conf = getConfiguration();
	const thi = conf.thi;
    const htc = conf.htc?.ht ?? null;
	let imagesMap = new Map();

    if (thi?.length > 0) {
        try {
            const imagesData = JSON.parse(thi);
            imagesMap = new Map(Object.entries(imagesData));
        } catch (e) {}
    }

    if (htc?.length > 0) {
        htc.forEach(t => {
            if (t.url?.length > 0) {
                imagesMap.set(t.id, t.url);
            }
        });
    }
	
	return imagesMap;
}
